import axiosInstance from './axiosInstance';

export const getPlans = () => axiosInstance.get('/plans');
export const subscribe = (planId) => axiosInstance.post('/plans/subscribe', { planId });
export const getPlansWithStatus = () => axiosInstance.get('/plans/with-status');
export const buySlot = (planId, walletType) => axiosInstance.post('/plans/buy-slot', { planId, walletType });
export const renewSlot = (planId, walletType) => axiosInstance.post('/plans/renew-slot', { planId, walletType });
